import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const AppointmentsPage = lazy(() =>
  import("./pages/AppointmentsPage").then((m) => ({ default: m.AppointmentsPage }))
);
const AppointmentNewPage = lazy(() =>
  import("./pages/AppointmentNewPage").then((m) => ({ default: m.AppointmentNewPage }))
);
const AppointmentEditPage = lazy(() =>
  import("./pages/AppointmentEditPage").then((m) => ({ default: m.AppointmentEditPage }))
);

export const AppointmentRoutes: RouteObject = {
  path: "/appointments",
  children: [
    {
      index: true,
      element: <AppointmentsPage />,
    },
    {
      path: "new",
      element: <AppointmentNewPage />,
    },
    {
      path: ":id/edit",
      element: <AppointmentEditPage />,
    },
  ],
};

export default AppointmentRoutes;
